export default "__VITE_ASSET__BD2S3AJ1__"